module.exports = __webpack_public_path__ + "static/media/img6.0db8dab7.jpg";